export const esTranslation = {
  header: {
    homeProjectors: "Proyectores de hogar",
    portableProjectors: "Proyectores portátiles",
    support: "Soporte",
    promotion: "Promoción",
    dropdownHome: "Modelos de proyectores de hogar y accesorios",
    dropdownPortable: "Modelos de proyectores portátiles y bancos de energía",
    dropdownSupport: "Preguntas frecuentes, manuales e información de contacto",
  },
  main: {
    fastSelfHelpSupport: "Autosoporte rápido",
    card1: {
      title: "Preguntas de preventa",
      description: "¿Cómo comprar con un gran descuento?",
      link: "Aprende más",
    },
    card2: {
      title: "Soporte de productos",
      description: "¿Tiene problemas para usar su proyector?",
      link: "Seleccione su modelo",
    },
    card3: {
      title: "Servicio postventa",
      description: "Garantía, política de devolución y cambio",
      link: "Aprende más",
    },
    getSupport: {
      title: "Obtenga nuestro apoyo",
      replyTime: "Normalmente respondemos en 1 día hábil.",
      checkFaq:
        "Para problemas con el dispositivo, consulte primero el {faqLink}",
    },
  },
  form: {
    name: "Nombre",
    email: "Correo electrónico",
    order_id: "Su número de pedido",
    orderNumberHelp: "¿Cómo encontrar mi número de pedido?",
    describeIssue: "Por favor describa el problema",
    descriptionHelp:
      "Proporcione tantas fotos y videos del fallo como sea posible para que podamos determinar rápidamente la solución.",
    fileUpload: "Carga de archivos",
    fileUploadInstructions: "{action} archivos a esta área para cargarlos.",
    fileUploadInstructionsAction: "Haga clic o arrastre",
    fileUploadLimit: "Puede cargar hasta 5 archivos.",
    filesSelected: "{{count}}/5 archivos seleccionados.",
    maxFilesError: "Puede cargar un máximo de 5 archivos.",
    surveyTitle:
      "Una pequeña encuesta: ¿qué mejoras le gustaría que tuviera su próximo proyector?",
    surveyPlaceholder: "ej: quiero que sea más brillante, más ruidoso, etc.",
    submit: "Enviar",
    nextButton: "Siguiente",
    previousButton: "Anterior",
    submitSuccess:
      "¡Ticket de soporte enviado! Nos pondremos en contacto con usted pronto.",
    step2: {
      expectation: {
        label: "¿Cumple con tus expectativas?",
        optionYes: "Sí, funciona bien",
        optionNo: "No, tiene problemas",
      },
      rating: {
        label: "¿Cómo lo calificarías?",
      },
      features: {
        label:
          "Una pequeña encuesta: ¿qué características de nuestros productos le atraen más?",
        placeholder:
          "Por ejemplo: apariencia, precio asequible, diseño único, etc.",
      },
    },
    step3: {
      title: "¡Reclame su regalo de activación! ¡Es gratis!",
      gift1Title: "1 año de garantía extra",
      gift2Title: "180 días de reemplazo gratuito",
      confirmation:
        "Le enviaremos un correo electrónico de confirmación a su buzón, por favor confirme la recepción en el correo electrónico.",
      activateButton: "Activar ahora",
    },
    step4: {
      title: "¡Ha activado su garantía con éxito!",
      line1:
        "Espero que le guste el regalo de activación que hemos preparado para usted.",
      line2:
        "Ha recibido un correo electrónico de confirmación. Por favor, revise su bandeja de entrada para confirmar los beneficios seleccionados.",
      line3: "Si no lo encuentra, revise su carpeta de correo no deseado.",
    },
    errors: {
      nameRequired: "El nombre es obligatorio.",
      emailRequired: "El correo electrónico es obligatorio.",
      emailInvalid: "El correo electrónico no es válido.",
      order_idRequired: "El número de pedido es obligatorio.",
      order_idInvalid:
        "Formato de número de pedido no válido (p. ej., XXX-XXXXXXX-XXXXXXX).",
      commentRequired: "Por favor describa el problema.",
      filesRequired: "Se requiere al menos un archivo.",
      surveyRequired: "El campo de la encuesta es obligatorio.",
      expectationRequired: "Por favor seleccione una opción.",
      ratingRequired: "Por favor proporcione una calificación.",
      featuresRequired: "Este campo de la encuesta es obligatorio.",
      giftRequired: "Por favor, seleccione un regalo para activar.",
    },
  },
  footer: {
    newsletterTitle: "Únase a nuestro boletín",
    newsletterDescription:
      "Suscríbase a nuestro boletín para recibir noticias personalizadas de productos, actualizaciones e invitaciones especiales",
    emailPlaceholder: "Dirección de correo electrónico",
    signUp: "Registrarse",
    products: "Productos",
    support: "Soporte",
    contactUs: "Contáctenos",
    preSales: "Preguntas de preventa",
    productSupport: "Soporte de productos",
    afterSales: "Servicio postventa",
    contactInfo: "Información de contacto",
    workingHours: "(CST): Lun-Dom 9am-7pm",
  },
  contactUs: {
    title: "Contáctanos",
    description: "Si su proyector tiene algunos problemas que no puede resolver, póngase en contacto con nosotros a tiempo y complete el formulario. Le responderemos dentro de las 24 horas para ayudarle a resolverlo. También puede contactarnos en línea de 18:30 PM-6:30 AM hora del Pacífico.",
    email: "Email",
    emailAddress: "vip_service@elephas.com.hk",
    phone: "Tel(US)",
    phoneNumber: "+1 (561) 309-3306",
    workingHours: "Lun-Vie 9:00 AM-5:00 PM (PT)",
    form: {
      name: "Nombre",
      email: "Email",
      country: "País",
      productModel: "Modelo del producto",
      amazonOrderNumber: "Número de pedido de Amazon",
      problemsEncountered: "Problemas encontrados",
      problemsPlaceholder: "Por favor describa los problemas que encontró...",
      submit: "Enviar",
      submitting: "Enviando...",
      submitSuccess: "¡Gracias! Su mensaje ha sido enviado exitosamente. Le responderemos dentro de las 24 horas.",
      errors: {
        nameRequired: "El nombre es requerido.",
        emailRequired: "El email es requerido.",
        emailInvalid: "Por favor ingrese una dirección de email válida.",
        countryRequired: "El país es requerido.",
        amazonOrderNumberRequired: "El número de pedido de Amazon es requerido.",
      },
    },
  },
};
